import React from 'react';
import styled from '@emotion/styled';
import { Result } from '../types';

const OuterBox = styled.div`
  box-shadow: 0px 12px 24px -4px rgba(145, 158, 171, 0.12);
  border-radius: 6px;
  width: 440px;
  margin-top: 8px;
`;
const InnerBox = styled.div`
  padding: 8px 16px;
`;
const HeaderInfo = styled.div`
  font-weight: bold;
  margin-top: 30px;
  background: #f7f7f9;
  border-radius: 6px 6px 0px 0px;
  padding: 24px 16px;
  font-size: 18px;
  border-bottom: 1px solid #E5E5EA;
`;
interface Props{
  property: Result;
}
const OwnershipInformation = (props:Props) => {
  return (
    <OuterBox>
      <HeaderInfo>Ownership Information</HeaderInfo>
      <InnerBox>
        <div style={{color: '#8E8E93'}}>Owner Name</div>
        <div>{props.property?.owners}</div>
      </InnerBox>
      {props.property?.mailingAddress && <InnerBox>
        <div style={{color: '#8E8E93'}}>Mailing Address</div>
        <div>{props.property?.mailingAddress}</div>
      </InnerBox>}
    </OuterBox>
  );
};

export default OwnershipInformation;
